import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './master/base.service';
import { APIService } from './master/api.service';
import { apiUrl } from '../schema/api-url';
import { AUTH } from 'src/app/constant/constant';
import { saveAs } from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class NguoicocongService extends BaseService {

    constructor(private _apiService: APIService, private http: HttpClient) {
        super(_apiService);
    }

    bodyToString(body): string {
        var queryString = Object.keys(body)
        .filter(key => body[key] != null && body[key] !== "" && body[key] !== "null")
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key]))
        .join('&');
        return queryString;
    }

    /**
     * @author ToiTV
     * Get HoSo type list
     * 2020-10-15
     */
    getListLoaiHS(): Observable<any> {
       return super.get(apiUrl.NGUOI_CO_CONG.SEARCH.RECORD_TYPE +'?trangThaiXoa=false&trangThaiHoatDong=true');
    }

    /**
     * @author ToiTV
     * Get Province
     * 2020-10-16
     */
    getTinh(): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.SEARCH.PROVINCE);
    }

    /**
     * @author ToiTV
     * Get District
     * 2020-10-16
     */
    getHuyen(tinhID): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.SEARCH.DISTRICT, { tinhID: tinhID });
    }

    /**
     * @author ToiTV
     * Get District
     * 2020-10-16
     */
    getXa(huyenID): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.SEARCH.TOWN, { huyenID: huyenID });
    }

    /**
     * @author ToiTV
     * Get DanToc
     * 2020-10-16
     */
    getDanToc(): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.SEARCH.NATION);
    }

    /**
     * @author ToiTV
     * Get DanToc
     * 2020-10-16
     */
    searchList(obj): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.SEARCH.SEARCH, obj);
    }

    /**
     * @author ToiTV
     * Export data with condition search
     * 2020-10-17
     */
    exportData(obj: any, fileName: string, type: number): Observable<any> {
        const queryString = Object.entries(obj)
        .filter(([_, value]) =>
            value !== null &&
            value !== undefined &&
            !(typeof value === 'string' && value.trim() === '')
        )
        .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
        .join('&');
        var url = type == 0 ? apiUrl.NGUOI_CO_CONG.SEARCH.EXPORT : apiUrl.NGUOI_CO_CONG.SEARCH.EXPORT_PDF;
        return super.downloadFile(url + "?" + queryString, fileName);
    }

    /**
     * @author ToiTV
     * Get category list
     * 2020-10-18
     */
    getListCategory(): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.HO_SO_LIET_SI.GENERAL_INFORMATION.CATEGORY);
    }

    /**
     * @author ToiTV
     * Get Information of profile
     * 2020-10-26
     */
    getTabs(loaiHoSoID): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.TABS, { loaiHoSoId: loaiHoSoID, trangThaiXoa : false , trangThaiHoatDong : true });
    }

    

    /**
     * @author ToiTV
     * Get list attached file
     * @param heroID
     */
    getListAttachment(heroID): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.HO_SO_LIET_SI.ATTACHMENT_INFORMATION.GET, { hoSoID: heroID });
    }

    /**
     * @author ToiTV
     * Upload file
     * @param data
     */
    upload(data): Observable<HttpEvent<any>> {

        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        const req = new HttpRequest('POST', apiUrl.NGUOI_CO_CONG.HO_SO_LIET_SI.ATTACHMENT_INFORMATION.UPLOAD, data, {
            reportProgress: true, headers
        });

        return this.http.request(req)
    }

    /**
     * @author ToiTV
     * Delete file
     * @param fileID
     */
    delete(fileID): Observable<any> {
        return super.delete(apiUrl.NGUOI_CO_CONG.HO_SO_LIET_SI.ATTACHMENT_INFORMATION.DELETE, { fileID: fileID });
    }

    /**
     * @author ToiTV
     * Download file
     * @param originalFileName
     * @param folderName
     */
    download(fileID, fileName): Observable<any> {
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.HO_SO_LIET_SI.ATTACHMENT_INFORMATION.DOWNLOAD + "/" + fileID, fileName);
    }

    /**
     * @author ToiTV
     * Download all
     * @param heroID
     */
    downloadAll(heroID, fileName): Observable<any> {
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.HO_SO_LIET_SI.ATTACHMENT_INFORMATION.DOWNLOAD_ALL + "?hoSoID=" + heroID, fileName);
    }    

    /**
     * @author ToiTV
     * Export Pdf Investigate
     */
    exportPdfInvestigate(data, fileName): Observable<any> {
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.EXPORT_PDF_INVESTIGATE, fileName, data);
    }

    /**
     * @author ToiTV
     * Export Pdf Investigate
     */
    deleteHoSo(hosoID): Observable<any> {
        return super.delete(apiUrl.NGUOI_CO_CONG.DELETE, { hosoID: hosoID });
    }

    /**
     * @author ToiTV
     * Write to log
     * @param data
     */
    writeToLog(newData, oldData, actionLog, content, page, code ?): Observable<any> {
        let logDetail = [];
        if (oldData && typeof oldData === "object") {
            if (Object.keys(oldData).length > 0) {
                Object.keys(oldData).forEach(key => {
                    var oldK = oldData[key];
                    var newK = newData[key];
                    if ((oldK != newK) && oldK !== undefined && newK !== undefined) {
                        if (oldK && oldK instanceof Date)
                            oldK = oldK.getDate() + "/" + (oldK.getMonth() + 1) + "/" + oldK.getFullYear();
                        if (newK && newK instanceof Date)
                            newK = newK.getDate() + "/" + (newK.getMonth() + 1) + "/" + newK.getFullYear();
                        logDetail.push({keyName: key, oldValue: oldK ? oldK : "", newValue: newK ? newK : ""});
                    }
                });
            } else {
                Object.keys(newData).forEach(key => {
                    var oldK = oldData[key];
                    var newK = newData[key];
                    if (oldK != newK) {
                        if (oldK && oldK instanceof Date)
                            oldK = oldK.getDate() + "/" + (oldK.getMonth() + 1) + "/" + oldK.getFullYear();
                        if (newK && newK instanceof Date)
                            newK = newK.getDate() + "/" + (newK.getMonth() + 1) + "/" + newK.getFullYear();
                        logDetail.push({keyName: key, oldValue: oldK ? oldK : "", newValue: newK ? newK : ""});
                    }
                });
            }
        }
        var body = {
            page: page,
            action: actionLog,
            content: content,
            detail: logDetail,
            code : code
        }
        return super.post(apiUrl.NGUOI_CO_CONG.LOG.UPDATE, body);
    }

    /**
     * @author ToiTV
     * Get log
     * @param data
     */
    GetLog(body): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.LOG.GET, body);
    }

    /**
     * @author ToiTV
     * Get detail log
     * @param data
     */
    GetDetailLog(logId): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.LOG.GET_DETAIL, {logId: logId});
    }

    /*AnhNT*/
    getBCQDTheoQuy(requestBody?){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.DESICION_STATUS_REPORT, requestBody,this.getRequestOptions());
    }

    /*AnhNT*/
    getBCQDTheoQuyxlsx(requestBody?){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.DESICION_STATUS_REPORT,'Thống kê quyết định trợ cấp' ,requestBody);
    }
    /*AnhNT*/
    getRequestOptions() {
        let requestOptions = {
          responseType: 'blob' as 'json',
          headers: this.getHeader()
        };
        return requestOptions;
    }
    /*AnhNT*/
      getHeader() {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers = headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        return headers;
      }
    /*AnhNT*/
    getListQD62(body){
        return super.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.QD62, body);
    }

    /*AnhNT*/
    exportListQD62(obj: any, fileName: string): Observable<any> {
        var param = '';
        Object.keys(obj).forEach(key => {
            param += key + '=' + obj[key] + '&';
        });
        var url =  apiUrl.NGUOI_CO_CONG.BAO_CAO.EXPORTQD62 ;
        return super.downloadFile(url + "?" + param, fileName);
    }

    getBasicInfoByCMND(cmnd) {
        return super.get(apiUrl.NGUOI_CO_CONG.BASICINFO, { cmnd: cmnd });
    }

    getDSTongHopKinhPhiTheoQuy(requestBody?){
        return super.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.THKP_LIST, requestBody);
    }

    getTongHopKinhPhiTheoQuy(requestBody?){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.THKP_REPORT, requestBody, this.getRequestOptions());
    }

    saveTongHopKinhPhiTheoQuy(list){
        return super.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.SAVE_THKP_REPORT, list);
    }

    getTongHopKinhPhiTheoQuyxlsx(requestBody?){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.THKP_REPORT,'tong-hop-kinh-phi-theo-quy-p1' ,requestBody);
    }

    getTongHopKinhPhiTheoQuyP2(requestBody?){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.THKP_P2_REPORT, requestBody,this.getRequestOptions());
    }

    getTongHopKinhPhiTheoQuyP2xlsx(requestBody?){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.THKP_P2_REPORT,'tong-hop-kinh-phi-theo-quy-p2' ,requestBody);
    }

    xuatFileImport(obj, loaiHoSoID, maTinh): Observable<any> {
        let api;
        if(maTinh == '93' && (loaiHoSoID == 6 || loaiHoSoID == 10)){
            api = apiUrl.NGUOI_CO_CONG.TEMPLATE_TB_LS;
        }else{
            api = apiUrl.NGUOI_CO_CONG.TEMPLATE;
        }
        if(obj.maXa != null && obj.maXa != "null") {
          api += "?maXa=" + obj.maXa;
          if(maTinh == '93' && loaiHoSoID == 6) api += "&loaiHoSo=THUONG_BINH";
          if(maTinh == '93' && loaiHoSoID == 10) api += "&loaiHoSo=LIET_SI";
        }else{
            if(maTinh == '93' && loaiHoSoID == 6) api += "?loaiHoSo=THUONG_BINH";
            if(maTinh == '93' && loaiHoSoID == 10) api += "?loaiHoSo=LIET_SI";
        }

        return super.downloadFile(api, "File mẫu import người có công.xlsx",{});
    }

    uploadFileImport(file,data, loaiHoSoID, maTinh): Observable<any> {
        let api;
        if(maTinh == '93'){
            if(loaiHoSoID == 5) api = apiUrl.NGUOI_CO_CONG.IMPORT_TB;
            if(loaiHoSoID == 10) api = apiUrl.NGUOI_CO_CONG.IMPORT_LS;
            if(loaiHoSoID != 10 && loaiHoSoID != 6) api = apiUrl.NGUOI_CO_CONG.IMPORT;
        }else{
            api = apiUrl.NGUOI_CO_CONG.IMPORT;
        }
        const queryString = Object.entries(data).filter(([key, value]) => value !== null).map(([key, value]) => `${key}=${value}`).join('&');
        return super.post(api + "?" + queryString, file);
    }

    uploadFileImportLoi(file,data, loaiHoSoID, maTinh): Observable<any> {
        let api;
        if(maTinh == '93'){
            if(loaiHoSoID == 6) api = apiUrl.NGUOI_CO_CONG.IMPORT_TB;
            if(loaiHoSoID == 10) api = apiUrl.NGUOI_CO_CONG.IMPORT_LS;
        }else{
            api = apiUrl.NGUOI_CO_CONG.IMPORT;
        }
        const queryString = Object.entries(data).filter(([key, value]) => value !== null).map(([key, value]) => `${key}=${value}`).join('&');
        return super.downloadFile(api + "?" + queryString,'File import lỗi người có công.xlsx' ,file);
    }

    getDSTongHopKinhPhiTheoQuyP2(requestBody?){
        return super.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.THKP_P2_LIST, requestBody);
    }

    saveTongHopKinhPhiTheoQuyP2(list){
        return super.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.SAVE_THKP_P2_REPORT, list);
    }

    getEncryptionKey() {

    }

    getLoginKey() {

    }

    gettest() {

    }

    getBlobFile(fileID: string): Observable<Blob> {
        return super.getBlob(apiUrl.NGUOI_CO_CONG.HO_SO_LIET_SI.ATTACHMENT_INFORMATION.DOWNLOAD + "/" + fileID);
    }

    hashSign(obj): Observable<any> {
        let requestOptions = {
        responseType: 'blob' as 'json',
        headers: new HttpHeaders({
            Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            'Content-Type': 'application/json'
        })
    };

    return this.http.post(apiUrl.SmartCA.hashSign, obj, requestOptions);
    }

    //dich vu cong
    getDanhSach(data) {
        return super.post(apiUrl.NGUOI_CO_CONG.DVC.DANH_SACH, data);
    }

    chuyenDuyet(obj) {
        return super.put(apiUrl.NGUOI_CO_CONG.DVC.CHUYEN_DUYET, obj);
    }

    chuyenDuyetTatCa(trangThai, maTinh) {
        return super.put(apiUrl.NGUOI_CO_CONG.DVC.CHUYEN_DUYET_DS+ "?trangThai=" + trangThai+ "&maTinh=" + maTinh, {});
    }

    tuChoi(id, trangThai) {
        return super.delete(apiUrl.NGUOI_CO_CONG.DVC.TU_CHOI + "?id=" + id + "&trangThaiXoa=" + trangThai);
    }

    updateDvc(obj) {
        return super.put(apiUrl.NGUOI_CO_CONG.DVC.CAP_NHAT,obj);
    }

    token(obj){
        return super.post(apiUrl.SmartCA.token, obj);
    }

    list(obj): Observable<any> {
        return super.post(apiUrl.SmartCA.list, obj);
    }

    send(obj): Observable<any> {
        return super.post(apiUrl.SmartCA.sign, obj);
    }

    gettraninfo(obj): Observable<any> {
        return super.post(apiUrl.SmartCA.gettraninfo, obj);
    }

    refershVanBan(thongtinchedoid, refTranId, trangThaiKySo): Observable<any> {
        return super.put(apiUrl.SmartCA.refershVanBan + "?thongtinchedoid=" + thongtinchedoid + "&refTranId=" + refTranId + "&trangThaiKySo=" + trangThaiKySo);
    }
    getDanhSachFile(id) {
        return super.get(apiUrl.NGUOI_CO_CONG.DVC.LIST_HO_SO, {id: id});
    }

    getFileHoSoNcc(idHoSo, fileName): Observable<any> {
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.DVC.GET_HO_SO + "/" + idHoSo, fileName);
    }
    getBCDSTCThang(requestBody?){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.DSTCHT, requestBody,this.getRequestOptions());
    }
    getBCDSTCThangxlsx(requestBody?){
        return  super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.DSTCHT,'Báo cáo danh sách trợ cấp hàng tháng' ,requestBody);
    }
    getBCDSHuong2CheDo(requestBody?){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.DSH2CD, requestBody,this.getRequestOptions());
    }
    getBCDSHuong2CheDoxlsx(requestBody?){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.DSH2CD,'Báo cáo danh sách hưởng 2 chế độ' ,requestBody);
    }

    getBCDSChiTraMLTheoThang(requestBody?){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.DSCTTCML, requestBody,this.getRequestOptions());
    }
    getBCDSChiTraMLTheoThangxlsx(requestBody?){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.DSCTTCML,'Danh sách chi trả trợ cấp ưu đãi một lần theo tháng' ,requestBody);
    }
    getBangTongHopKinhPhi(requestBody?){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.BANG_THKP, requestBody,this.getRequestOptions());
    }
    getBangTongHopKinhPhixlsx(requestBody?){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.BANG_THKP,'Bảng tổng hợp kinh phí người có công' ,requestBody);
    }
    getBCTinhHinhChiTraTCML(requestBody?){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.BCTHCTML, requestBody,this.getRequestOptions());
    }
    getBCTinhHinhChiTraTCMLxlsx(requestBody?){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.BCTHCTML,'Báo cáo tình hình trợ cấp một lần' ,requestBody);
    }

    // Liệt sĩ AGG
    AGGGetListHsLietSi(obj):Observable<any> {
      return super.post(apiUrl.AGG.HS_LIET_SI.GET_ALL, obj);
    }
    AGGUpdateHsLietSi(requestBody) {
      return super.put(apiUrl.AGG.HS_LIET_SI.UPDATE, requestBody);
    }
    AGGAddHsLietSi(requestBody) {
      return super.post(apiUrl.AGG.HS_LIET_SI.ADD, requestBody);
    }
    AGGGetDetailHsLietSi(id): Observable<any> {
      return super.get(apiUrl.AGG.HS_LIET_SI.DETAIL + "?id=" +id);
    }
    getTenQuanHuyenAnGiang() {
      return super.get(apiUrl.AGG.get_huyen_thi_thanh );
    }
    AGGDeleteHsLietSi(id, trang_thai_xoa): Observable<any> {
      return super.delete(apiUrl.AGG.HS_LIET_SI.DELETE + "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGDownloadTemplateImportHsLietSi(filename):Observable<any>{
      return super.downloadFile(apiUrl.AGG.HS_LIET_SI.DOWNLOAD_TEMPLATE, filename);
    }
    AGGImportExcelHsLietSi(obj,file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append("thang", obj.thang);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);
        let api = apiUrl.AGG.HS_LIET_SI.IMPORT_EXCEL;
        if(obj.nam != null && obj.nam != "null") {
          api += "?nam=" + obj.nam;
        }
        if(obj.thang != null && obj.thang != "null") {
          api += "&thang=" + obj.thang;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
    }
  // Bệnh binh AGG
    AGGGetListHsBenhBinh(obj):Observable<any> {
      return super.post(apiUrl.AGG.HS_BENH_BINH.GET_ALL, obj);
    }
    AGGUpdateHsBenhBinh(requestBody) {
      return super.put(apiUrl.AGG.HS_BENH_BINH.UPDATE, requestBody);
    }
    AGGAddHsBenhBinh(requestBody) {
      return super.post(apiUrl.AGG.HS_BENH_BINH.ADD, requestBody);
    }
    AGGGetDetailHsBenhBinh(id): Observable<any> {
      return super.get(apiUrl.AGG.HS_BENH_BINH.DETAIL + "?id=" +id);
    }
    AGGDeleteHsBenhBinh(id, trang_thai_xoa): Observable<any> {
      return super.delete(apiUrl.AGG.HS_BENH_BINH.DELETE + "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGDownloadTemplateImportHsBenhBinh(filename){
      return super.downloadFile(apiUrl.AGG.HS_BENH_BINH.DOWNLOAD_TEMPLATE, filename);
    }
    AGGImportExcelHsBenhBinh(obj,file): Observable<any> {
      const token = localStorage.getItem('access_token');
      let headers = new HttpHeaders();
      headers = headers.append('Authorization', 'Bearer ' + token);
      headers.append('Access-Control-Allow-Origin', '*');
      const formData = new FormData();
      formData.append("thang", obj.thang);
      formData.append("nam", obj.nam);
      formData.append("file", obj.file);
      let api = apiUrl.AGG.HS_BENH_BINH.IMPORT_EXCEL;
      if(obj.nam != null && obj.nam != "null") {
        api += "?nam=" + obj.nam;
      }
      if(obj.thang != null && obj.thang != "null") {
        api += "&thang=" + obj.thang;
      }
      return this.http.post(api, file, { reportProgress: true, headers });
    }

    // Người bị tù đày AGG
    AGGGetListHsNguoiBiTuDay(obj):Observable<any> {
        return super.post(apiUrl.AGG.HS_NGUOI_BI_TU_DAY.GET_ALL, obj);
    }
    AGGAddHsNguoiBiTuDay(obj):Observable<any> {
        return super.post(apiUrl.AGG.HS_NGUOI_BI_TU_DAY.ADD, obj);
    }
    AGGUpdateHsNguoiBiTuDay(requestBody) {
        return super.put(apiUrl.AGG.HS_NGUOI_BI_TU_DAY.UPDATE, requestBody);
    }
    AGGGetDetailHsNguoiBiTuDay(id): Observable<any> {
        return super.get(apiUrl.AGG.HS_NGUOI_BI_TU_DAY.DETAIL + "?id=" +id);
    }
    AGGDeleteHsNguoiBiTuDay(id, trang_thai_xoa): Observable<any> {
        return super.delete(apiUrl.AGG.HS_NGUOI_BI_TU_DAY.DELETE + "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGDownloadTemplateImportHsNguoiBiTuDay(filename){
        return super.downloadFile(apiUrl.AGG.HS_NGUOI_BI_TU_DAY.DOWNLOAD_TEMPLATE, filename);
    }
    AGGImportExcelHsNguoiBiTuDay(obj,file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append("thang", obj.thang);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);
        let api = apiUrl.AGG.HS_NGUOI_BI_TU_DAY.IMPORT_EXCEL;
        if(obj.nam != null && obj.nam != "null") {
        api += "?nam=" + obj.nam;
        }
        if(obj.thang != null && obj.thang != "null") {
        api += "&thang=" + obj.thang;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
    }
    // Lão thành cách mạng AGG
    AGGGetListHsLaoThanhCachMang(obj):Observable<any> {
    return super.post(apiUrl.AGG.HS_LAO_THANH_CACH_MANG.GET_ALL, obj);
    }
    AGGAddHsLaoThanhCachMang(obj):Observable<any> {
    return super.post(apiUrl.AGG.HS_LAO_THANH_CACH_MANG.ADD, obj);
    }
    AGGUpdateHsLaoThanhCachMang(requestBody) {
    return super.put(apiUrl.AGG.HS_LAO_THANH_CACH_MANG.UPDATE, requestBody);
    }
    AGGGetDetailHsLaoThanhCachMang(id): Observable<any> {
    return super.get(apiUrl.AGG.HS_LAO_THANH_CACH_MANG.DETAIL+ "?id=" +id);
    }
    AGGDeleteHsLaoThanhCachMang(id, trang_thai_xoa): Observable<any> {
    return super.delete(apiUrl.AGG.HS_LAO_THANH_CACH_MANG.DELETE+ "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGImportExcelHsLaoThanhCachMang(obj,file): Observable<any> {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');
    const formData = new FormData();
    formData.append("thang", obj.thang);
    formData.append("nam", obj.nam);
    formData.append("file", obj.file);
    let api = apiUrl.AGG.HS_LAO_THANH_CACH_MANG.IMPORT_EXCEL;
    if(obj.nam != null && obj.nam != "null") {
        api += "?nam=" + obj.nam;
    }
    if(obj.thang != null && obj.thang != "null") {
        api += "&thang=" + obj.thang;
    }
    return this.http.post(api, file, { reportProgress: true, headers });
    }
    AGGDownloadTemplateImportHsLaoThanhCachMang(filename){
    return super.downloadFile(apiUrl.AGG.HS_LAO_THANH_CACH_MANG.DOWNLOAD_TEMPLATE, filename);
    }
  // Mẹ việt nam AGG
   AGGGetListHsMVNAH(obj):Observable<any> {
    return super.post(apiUrl.AGG.ME_VIET_NAM_ANH_HUNG.GET_DANH_SACH_ME_VIET_NAM_ANH_HUNG, obj);
    }
    AGGAddHsMVNAH(obj):Observable<any> {
        return super.post(apiUrl.AGG.ME_VIET_NAM_ANH_HUNG.THEM_HS_ME_VIET_NAM_ANH_HUNG, obj);
    }
    AGGEditHsMVNAH(requestBody) {
        return super.put(apiUrl.AGG.ME_VIET_NAM_ANH_HUNG.CAP_NHAT_HS_ME_VIET_NAM_ANH_HUNG, requestBody);
    }
    AGGGetDetailHsMVNAH(id): Observable<any> {
        return super.get(apiUrl.AGG.ME_VIET_NAM_ANH_HUNG.CHI_TIET_HS_ME_VIET_NAM_ANH_HUNG+ "?id=" +id);
    }
    AGGDeleteHsMVNAH(id, trang_thai_xoa): Observable<any> {
        return super.delete(apiUrl.AGG.ME_VIET_NAM_ANH_HUNG.XOA_HS_ME_VIET_NAM_ANH_HUNG + "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGImportExcelHsMVNAH(obj,file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append("thang", obj.thang);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);
        let api = apiUrl.AGG.ME_VIET_NAM_ANH_HUNG.IMPORT_DS_ME_VIET_NAM_ANH_HUNG;
        if(obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }
        if(obj.thang != null && obj.thang != "null") {
            api += "&thang=" + obj.thang;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
        }
    AGGDownloadTemplateImportHsMVNAH(filename): Observable<any>{
        return super.downloadFile(apiUrl.AGG.ME_VIET_NAM_ANH_HUNG.DOWNLOAD_TEMPLATE, filename);
        }

    uploadFileImportMo(obj): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append("file", obj.file);

        let api = apiUrl.NGUOI_CO_CONG.IMPORT_MO;
        if(obj.maXa != null && obj.maXa != "null") api += "&maXa=" + obj.maXa;
        
        return this.http.post(api, formData, { reportProgress: true, headers });
    }
    xuatFileImportMo(obj): Observable<any> {
        let api = apiUrl.NGUOI_CO_CONG.TEMPLATE_IMPORT_MO;
        return super.downloadFile(api, "File mẫu import mộ người có công.xlsx",{});
    }

    // Hoạt động kháng chiến AGG
    AGGGetListHsHDKC(obj):Observable<any> {
      return super.post(apiUrl.AGG.HOAT_DONG_KHANG_CHIEN.GET_DANH_SACH_HOAT_DONG_KHANG_CHIEN, obj);
    }
    AGGAddHsHDKC(obj):Observable<any> {
      return super.post(apiUrl.AGG.HOAT_DONG_KHANG_CHIEN.THEM_HS_HOAT_DONG_KHANG_CHIEN, obj);
    }
    AGGEditHsHDKC(requestBody) {
      return super.put(apiUrl.AGG.HOAT_DONG_KHANG_CHIEN.CAP_NHAT_HS_HOAT_DONG_KHANG_CHIEN, requestBody);
    }
    AGGGetDetailHsHDKC(id): Observable<any> {
      return super.get(apiUrl.AGG.HOAT_DONG_KHANG_CHIEN.CHI_TIET_HS_HOAT_DONG_KHANG_CHIEN+ "?id=" +id);
    }
    AGGDeleteHsHDKC(id, trang_thai_xoa): Observable<any> {
      return super.delete(apiUrl.AGG.HOAT_DONG_KHANG_CHIEN.XOA_HS_HOAT_DONG_KHANG_CHIEN+ "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGImportExcelHsHDKC(obj,file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append("thang", obj.thang);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);
        let api = apiUrl.AGG.HOAT_DONG_KHANG_CHIEN.IMPORT_DS_HOAT_DONG_KHANG_CHIEN;
        if(obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }
        if(obj.thang != null && obj.thang != "null") {
            api += "&thang=" + obj.thang;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
        }
    AGGDownloadTemplateImportHsHDKC(filename): Observable<any>{
        return super.downloadFile(apiUrl.AGG.HOAT_DONG_KHANG_CHIEN.DOWNLOAD_TEMPLATE, filename);
        }

    // Cau hinh form ncc

    getCauHinh(data){
        return super.post(apiUrl.NGUOI_CO_CONG.CAU_HINH.TIM_KIEM , data);
    }


    // APi dùng chung - tab trợ cấp

    getDSTroCap(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.TRO_CAP +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateTroCap(data){
        return super.post(apiUrl.NGUOI_CO_CONG.TRO_CAP, data);
    }

    deleteTroCap(thongTinCheDoUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.TRO_CAP +'?thongTinCheDoUuid=' +thongTinCheDoUuid);
    }

    // APi dùng chung - tab thân nhân

    getDSThanNhan(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THAN_NHAN +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    getDSThanNhanKhongCatChet(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THAN_NHAN_KHONG_CAT_CHET +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateThanNhan(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THAN_NHAN, data);
    }

    deleteThanNhan(thongTinCheDoUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THAN_NHAN +'?thongTinThanNhanUuid=' +thongTinCheDoUuid);
    }

    // APi dùng chung - tab đời sống

    getDSDoiSong(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.DOI_SONG +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateDoiSong(data){
        return super.post(apiUrl.NGUOI_CO_CONG.DOI_SONG, data);
    }

    deleteDoiSong(thongTinCheDoUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.DOI_SONG +'?thongTinDoiSongUuid=' +thongTinCheDoUuid);
    }

    // APi dùng chung - tab trợ cấp qua đời

    getDSTroCapQuaDoi(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.TRO_CAP_QUA_DOI +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateTroCapQuaDoi(data){
        return super.post(apiUrl.NGUOI_CO_CONG.TRO_CAP_QUA_DOI, data);
    }

    deleteTroCapQuaDoi(thongTinTroCapKhiQuaDoiUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.TRO_CAP_QUA_DOI +'?thongTinTroCapKhiQuaDoiUuid=' +thongTinTroCapKhiQuaDoiUuid);
    }

    // APi dùng chung - tab quá trình hoạt động cách mạng

    getDSQuaTrinhHDCM(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.QUA_TRINH_HOAT_DONG_CACH_MANG +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateQuaTrinhHDCM(data){
        return super.post(apiUrl.NGUOI_CO_CONG.QUA_TRINH_HOAT_DONG_CACH_MANG, data);
    }

    deleteQuaTrinhHDCM(thongTinQuaTrinhHoatDongUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.QUA_TRINH_HOAT_DONG_CACH_MANG +'?thongTinQuaTrinhHoatDongUuid=' + thongTinQuaTrinhHoatDongUuid);
    }

    // APi dùng chung - tab thông tin không công nhận

    getDSKhongCongNhan(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_KHONG_CONG_NHAN +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateKhongCongNhan(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_KHONG_CONG_NHAN, data);
    }

    deleteKhongCongNhan(thongTinKhongCongNhanUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_KHONG_CONG_NHAN +'? thongTinKhongCongNhanUuid=' + thongTinKhongCongNhanUuid);
    }

    // APi dùng chung - tab thông tin khen thưởng

    getDSKhenThuong(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_KHEN_THUONG +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateKhenThuong(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_KHEN_THUONG, data);
    }

    deleteKhenThuong(thongTinKhenThuongUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_KHEN_THUONG +'?thongTinKhenThuongUuid=' +thongTinKhenThuongUuid);
    }

    // APi dùng chung - tab thông tin gia đình
    getDSGiaDinh(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_GIA_DINH +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateGiaDinh(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_GIA_DINH, data);
    }

    deleteGiaDinh(thongTinGiaDinhUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_GIA_DINH +'?thongTinGiaDinhUuid=' +thongTinGiaDinhUuid);
    }

    // APi dùng chung - tab thông tin đối tượng khác

    getDSDTKhac(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_DOI_TUONG_KHAC +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateDTKhac(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_DOI_TUONG_KHAC, data);
    }

    deleteDTKhac(thuocDoiTuongKhacUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_DOI_TUONG_KHAC +'?thuocDoiTuongKhacUuid=' +thuocDoiTuongKhacUuid);
    }

    // APi dùng chung - tab thông tin thôi hưởng

    getDSThoiHuong(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_THOI_HUONG +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateThoiHuong(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_THOI_HUONG, data);
    }

    deleteThoiHuong(thongTinThoiHuongUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_THOI_HUONG +'?thongTinThoiHuongUuid=' +thongTinThoiHuongUuid);
    }

    // APi dùng chung - tab thông tin thu hồi

    getDSThuHoi(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_THU_HOI +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    insertOrUpdateThuHoi(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_THU_HOI, data);
    }

    deleteThuHoi(thongTinThuHoiUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_THU_HOI +'?thongTinThuHoiUuid=' +thongTinThuHoiUuid);
    }

    // Danh muc dung chung

    timKiemDanhMucChung(trangThaiXoa, danhMuc){
        return super.get(apiUrl.NGUOI_CO_CONG.TIM_KIEM_DANH_MUC  + '?trangThaiXoa= ' + trangThaiXoa +' &maDanhMuc=' + danhMuc);
    }

    getDanhMucChung(danhMuc){
        return super.get(apiUrl.NGUOI_CO_CONG.DANH_SACH_DANH_MUC + '?trangThaiXoa= ' + 'false' +' &maDanhMuc=' + danhMuc);
    }


    uploadFileImportOCR(obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwZDhmYTg1ZC0xNzE5LTY0YTktZTA2My02MzE5OWYwYTUyNTMiLCJhdWQiOlsicmVzdHNlcnZpY2UiXSwidXNlcl9uYW1lIjoic29ubnZ0LnRnZ0B2bnB0LnZuIiwic2NvcGUiOlsicmVhZCJdLCJpc3MiOiJodHRwczovL2xvY2FsaG9zdCIsIm5hbWUiOiJzb25udnQudGdnQHZucHQudm4iLCJ1dWlkX2FjY291bnQiOiIwZDhmYTg1ZC0xNzE5LTY0YTktZTA2My02MzE5OWYwYTUyNTMiLCJhdXRob3JpdGllcyI6WyJVU0VSIl0sImp0aSI6IjY4NDcwZjcyLTcxMjEtNGJlYS04MDFiLTUwMGI4NjQ4MjgyNiIsImNsaWVudF9pZCI6ImFkbWluYXBwIn0.S-RR0wike_3PRV40CBsUH0SHDi89ISkQNPjdTNM3xS4BYWSyg8JkbULr9dy5DS9c3biSSPafZx2IBmCk8C7KXesxnbmre4hV0a4Ups5KK5M0qnAs7GWZaemvui8-93JGU-GIc4ld9no1sgh0Hc5LFEf8i6BJMfkR-Cx1woiACUztpHwC0SaGddIRHVAiFXy0ncusDckXo8Bs7SVog7s7wIxflbGA9-tMoCesWpdsuy7sp9qmZg9P0kiWUPLN2VD3mSiojYoaxwGdeQ_XYncgTozXv6Yee1ONE-Axz4jmVBU0w1uxlskafUZ2a3EQxUa8vK1oXof9JWfUx5fcS-DrLg",
                'Token-id': '0d8fac7a-24aa-77f7-e063-63199f0a8c8b',
                'Token-key': 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJXoN8dE+FHTVtB73CFcaxts42EqnnjcnUfJI+YTzkXmzd9VRnYO+l8mkIP574Y8LQwSG8e+K9/YoSm6Fr/5MfsCAwEAAQ==',

            })
        };

        const formData = new FormData();
        formData.append("title", 'Hashing document');
        formData.append("description", 'Hashing document');
        formData.append("file", obj.file);

        return this.http.post(apiUrl.NGUOI_CO_CONG.OCR.importFile, formData, requestOptions);
    }

    bocTachFileOCR(requestBody?): Observable<any>{
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwZDhmYTg1ZC0xNzE5LTY0YTktZTA2My02MzE5OWYwYTUyNTMiLCJhdWQiOlsicmVzdHNlcnZpY2UiXSwidXNlcl9uYW1lIjoic29ubnZ0LnRnZ0B2bnB0LnZuIiwic2NvcGUiOlsicmVhZCJdLCJpc3MiOiJodHRwczovL2xvY2FsaG9zdCIsIm5hbWUiOiJzb25udnQudGdnQHZucHQudm4iLCJ1dWlkX2FjY291bnQiOiIwZDhmYTg1ZC0xNzE5LTY0YTktZTA2My02MzE5OWYwYTUyNTMiLCJhdXRob3JpdGllcyI6WyJVU0VSIl0sImp0aSI6IjY4NDcwZjcyLTcxMjEtNGJlYS04MDFiLTUwMGI4NjQ4MjgyNiIsImNsaWVudF9pZCI6ImFkbWluYXBwIn0.S-RR0wike_3PRV40CBsUH0SHDi89ISkQNPjdTNM3xS4BYWSyg8JkbULr9dy5DS9c3biSSPafZx2IBmCk8C7KXesxnbmre4hV0a4Ups5KK5M0qnAs7GWZaemvui8-93JGU-GIc4ld9no1sgh0Hc5LFEf8i6BJMfkR-Cx1woiACUztpHwC0SaGddIRHVAiFXy0ncusDckXo8Bs7SVog7s7wIxflbGA9-tMoCesWpdsuy7sp9qmZg9P0kiWUPLN2VD3mSiojYoaxwGdeQ_XYncgTozXv6Yee1ONE-Axz4jmVBU0w1uxlskafUZ2a3EQxUa8vK1oXof9JWfUx5fcS-DrLg",
                'Token-id': '0d8fac7a-24aa-77f7-e063-63199f0a8c8b',
                'Token-key': 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJXoN8dE+FHTVtB73CFcaxts42EqnnjcnUfJI+YTzkXmzd9VRnYO+l8mkIP574Y8LQwSG8e+K9/YoSm6Fr/5MfsCAwEAAQ==',
                'Access-Control-Allow-Origin': '*'

            })
        };
        return this.http.post(apiUrl.NGUOI_CO_CONG.OCR.bocTachFile, requestBody, requestOptions);
    }
  // Lão thành cách mạng AGG
  getDanhSachNguoiCoCongAhllvtKvAnGiang(obj):Observable<any> {
    return super.post(apiUrl.AN_GIANG.AHLLVT.GET_DANH_SACH_AHLLVT, obj);
  }
  themNguoiCoCongAhllvtKvAnGiang(obj):Observable<any> {
    return super.post(apiUrl.AN_GIANG.AHLLVT.THEM_HS_AHLLVT, obj);
  }
  capNhatNguoiCoCongAhllvtKvAnGiang(requestBody) {
    return super.put(apiUrl.AN_GIANG.AHLLVT.CAP_NHAT_HS_AHLLVT, requestBody);
  }
  chiTietNguoiCoCongAhllvtKvAnGiang(id): Observable<any> {
    return super.get(apiUrl.AN_GIANG.AHLLVT.CHI_TIET_HS_AHLLVT+ "?id=" +id);
  }
  deleteNguoiCoCongAhllvtKvAnGiang(id, trang_thai_xoa): Observable<any> {
    return super.delete(apiUrl.AN_GIANG.AHLLVT.XOA_HS_AHLLVT+ "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
  }
  uploadFileImportDSNguoiCoCongAhllvtKvAnGiang(obj): Observable<any> {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');
    const formData = new FormData();
    formData.append("thang", obj.thang);
    formData.append("nam", obj.nam);
    formData.append("file", obj.file);
    let api = apiUrl.AN_GIANG.AHLLVT.IMPORT_DS_AHLLVT
    return this.http.post(api, formData, { reportProgress: true, headers });
  }

    // AGG GIÚP ĐỞ CÁCH MẠNG
    AGGGetListHsGDCM(obj):Observable<any> {
        return super.post(apiUrl.AGG.GDCM.GET_DANH_SACH_GDCM, obj);
    }
    AGGAddHsGDCM(obj):Observable<any> {
        return super.post(apiUrl.AGG.GDCM.THEM_HS_GDCM, obj);
    }
    AGGEditHsGDCM(requestBody) {
        return super.put(apiUrl.AGG.GDCM.CAP_NHAT_HS_GDCM, requestBody);
    }
    AGGGetDetailHsGDCM(id): Observable<any> {
        return super.get(apiUrl.AGG.GDCM.CHI_TIET_HS_GDCM+ "?id=" +id);
    }
    AGGDeleteHsGDCM(id, trang_thai_xoa): Observable<any> {
        return super.delete(apiUrl.AGG.GDCM.XOA_HS_GDCM+ "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGImportExcelHsGDCM(obj,file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append("thang", obj.thang);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);
        let api = apiUrl.AGG.GDCM.IMPORT_DS_GDCM;
        if(obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }
        if(obj.thang != null && obj.thang != "null") {
            api += "&thang=" + obj.thang;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
        }
    AGGDownloadTemplateImportHsGDCM(filename): Observable<any>{
        return super.downloadFile(apiUrl.AGG.GDCM.DOWNLOAD_TEMPLATE, filename);
        }


    // Get data Nghĩa trang liệt sĩ
    getDataNghiaTrang(maTinh): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDataNghiaTrang + "?maTinh=" + maTinh);
    }

    // get data NCC theo huyện
    getDataNCCTheoHuyen(nam, maHuyen): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDataNCCTheoHuyen + "?nam=" + nam + "&maHuyen=" + maHuyen);
    }

    // get tỉ lệ NCC
    getDataNCCTheLoai(nam, maHuyen): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDataNCCTheoTyLe + "?nam=" + nam + "&maHuyen=" + maHuyen);
    }

    // Get data Mộ liệt sĩ theo huyện
    getDataNCCMoLietSiTheoHuyen(maTinh, maHuyen): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDataNCCMoLietSiTheoHuyen + "?maTinh=" + maTinh + "&maHuyen=" + maHuyen);
    }

    // get data label số lượng đối tượng nhận trợ cấp
    getDataLabelSLDtNhanTroCap(nam, maHuyen): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDataLabelSLDtNhanTroCap + "?nam=" + nam + "&maHuyen=" + maHuyen);
    }

    // Get danh mục nhóm đối tượng nhận trợ cấp
    getDMNhomDoiTuongNhanTroCap(): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDMNhomDoiTuongNhanTroCap);
    }

    // Get data chi trả trợ cấp theo nhóm
    getDataChiTraTheoThang(nam, thang, maHuyen, maNhom): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDataChiTraTheoThang + "?nam=" + nam + "&thang=" + thang + "&maHuyen=" + maHuyen + "&maNhom=" + maNhom);
    }

    // Get data chi trả trợ cấp theo huyện
    getDataChiTraTheoHuyen(nam, thang, maHuyen, maNhom): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDataChiTraTheoHuyen + "?nam=" + nam + "&thang=" + thang + "&maHuyen=" + maHuyen + "&maNhom=" + maNhom);
    }

    // Get data chi trả trợ cấp theo nhóm
    getDataChiTraTheoNhomDt(nam, thang, maHuyen, maNhom): Observable<any> {
        return super.get(apiUrl.AGG.DASHBOARD_NCC.getDataChiTraTheoNhomDt + "?nam=" + nam + "&thang=" + thang + "&maHuyen=" + maHuyen + "&maNhom=" + maNhom);
    }
    getLoaiQuyetDinh(data){
        return super.get(apiUrl.NGUOI_CO_CONG.DANH_MUC_LOAI_QUYET_DINH , data);
    }

    getDanhMuc(data){
        return super.get(apiUrl.NGUOI_CO_CONG.DANH_SACH_DANH_MUC + '?trangThaiXoa= ' + 'false', data );
    }

    capNhatDanhMucChung(data){
        return super.post(apiUrl.NGUOI_CO_CONG.CAP_NHAT_DANH_MUC , data);
    }

    deleteDanhMucChung(data){
        return super.delete(apiUrl.NGUOI_CO_CONG.CAP_NHAT_DANH_MUC , data);
    }

    //Danh muc den on dap nghia
    getDanhMucDenOnDapNghia(data){
        return super.get(apiUrl.NGUOI_CO_CONG.DANH_SACH_DEN_ON + "?" + this.bodyToString(data));
    }

    capNhatDanhMucDenOnDapNghia(data){
        return super.post(apiUrl.NGUOI_CO_CONG.CAP_NHAT_DEN_ON , data);
    }
    

    // Điều dưỡng

    insertOrUpdateDieuDuong(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TINH_DIEU_DUONG , data);
    }

    getDSDieuDuong(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null && data[key] != 'null') {
              param += key + '=' + data[key] + '&';
            }
        });
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TINH_DIEU_DUONG + "?" + param);
    }

    deleteDTDieuDuong(thongTinChiTraUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TINH_DIEU_DUONG +'?thongTinChiTraUuid=' +thongTinChiTraUuid + '&trangThaiXoa=true');
    }


    insertOrUpdateThoCungV2(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THO_CUNG.THONG_TINH_THO_CUNG , data);
    }

    getDSThoCungV2(data){
        return super.get(apiUrl.NGUOI_CO_CONG.THO_CUNG.THONG_TINH_THO_CUNG , data);
    }

    deleteThoCungV2(thongTinChiTraUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THO_CUNG.THONG_TINH_THO_CUNG +'?thongTinChiTraUuid=' +thongTinChiTraUuid);
    }

    lichSuChiTraDieuDuong(thongTinChiTraUuid){
        return super.get(apiUrl.NGUOI_CO_CONG.LICH_SU_DIEU_DUONG +'/' +thongTinChiTraUuid);
    }

    getMucChuan(){
        return super.get(apiUrl.NGUOI_CO_CONG.MUC_CHUANG_DIEU_DUONG);
    }

    // ưU đãi giáo dục

    insertOrUpdateUDGD(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TINH_UU_DAI_GIAO_DUC , data);
    }

    getDSUDGD(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                param += key + '=' + data[key] + '&';
            }
        });
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TINH_UU_DAI_GIAO_DUC + "?" + param);
    }

    deleteDTUDGD(thongTinChiTraUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TINH_UU_DAI_GIAO_DUC +'?thongTinChiTraUuid=' +thongTinChiTraUuid);
    }

    dmChiTraMoi(maDanhMucChiTra){
        return super.get(apiUrl.NGUOI_CO_CONG.DM_DOI_TUONG_UU_DAI_GIAO_DUC +'?maTroCap=' +maDanhMucChiTra);
    }

    // Phương tiện trợ giúp - dụng cụ chỉnh hình

    insertOrUpdatePTGD_DCCH(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TINH_PTTG_DCCH , data);
    }

    getDSPTGD_DCCH(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                param += key + '=' + data[key] + '&';
            }
        });
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TINH_PTTG_DCCH + "?" + param);
    }

    deleteDTPTGD_DCCH(thongTinChiTraUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TINH_PTTG_DCCH +'?thongTinChiTraUuid=' +thongTinChiTraUuid);
    }

    getHsHoSo(obj): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.HO_SO_CHUNG +"/" + obj);
    }

    deleteHsHoSo(obj): Observable<any> {
        return super.delete(apiUrl.NGUOI_CO_CONG.HO_SO_CHUNG +"?hoSoUuid="+ obj + '&trangThaiXoa=true');
    }

    taiQuyetDinh(api){
        return super.downloadFile(api, 'Quyết định NCC');
    }

    // Thông tin thờ cúng

    insertOrUpdateThoCung(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_THO_CUNG , data);
    }

    getDSThoCung(data){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_THO_CUNG , data);
    }

    deleteThoCung(thongTinThoCungUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_THO_CUNG +'?thongTinThoCungUuid=' +thongTinThoCungUuid + '&trangThaiXoa=true');
    }

    downloadFileFromAsset(assetPath: string, fileName: string): void {
        this.http.get(assetPath, { responseType: 'blob' }).subscribe(
          (response: Blob) => {
            saveAs(response, fileName);
          },
          (error) => {
            console.error('Error downloading file:', error);
          }
        );
    }

    // APi dùng chung - tab thông tin giám định adn

    getDSTTGiamDinhADN(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_GIAM_DINH_ADN +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    themMoiCapNhatTTGiamDinhADN(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_GIAM_DINH_ADN, data);
    }

    xoaTTGiamDinhADN(giamDinhUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_GIAM_DINH_ADN +'?giamDinhUuid=' +giamDinhUuid);
    }

    uploadFileADN(data): Observable<HttpEvent<any>> {
        return super.post(apiUrl.NGUOI_CO_CONG.UPLOAD_ADN, data);
    }

    // APi dùng chung - tab thông tin thân nhân thăm mộ

    getDSTTThanNhanThamMo(hoSoId, pageSize, pageNumber){
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_THAN_NHAN_THAM_MO +'?hoSoId=' +hoSoId + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
    }

    themMoiCapNhatTTThanNhanThamMo(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_THAN_NHAN_THAM_MO, data);
    }

    xoaTTThanNhanThamMo(thongTinThanNhanThamMoUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_THAN_NHAN_THAM_MO +'?thongTinThanNhanThamMoUuid=' +thongTinThanNhanThamMoUuid);
    }

    // Dashboard
    thongKeNCC(obj,loaiDashBoard) {
        if(loaiDashBoard == 'dash-board-ncc')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_NCC, obj);
        else if(loaiDashBoard == 'dash-board-tro-cap')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_NCC_TRO_CAP, obj);
        else if(loaiDashBoard == 'dash-board-chi-tra')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_NCC_CHI_TRA, obj);
        else if(loaiDashBoard == 'dash-board-mot-lan')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_NCC_MOT_LAN, obj);
        else if(loaiDashBoard == 'dash-board-hang-thang')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_NCC_HANG_THANG, obj);
    }

    thongKeNCCTheoHC(obj,loaiDashBoard) {
        if(loaiDashBoard == 'dash-board-ncc')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_HC, obj);
        else if(loaiDashBoard == 'dash-board-tro-cap')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_HC_TRO_CAP, obj);
        else if(loaiDashBoard == 'dash-board-chi-tra')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_HC_CHI_TRA, obj);
        else if(loaiDashBoard == 'dash-board-mot-lan')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_HC_MOT_LAN, obj);
        else if(loaiDashBoard == 'dash-board-hang-thang')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_HC_HANG_THANG, obj);
    }

    thongKeNCCTheoQuy(obj,loaiDashBoard) {
        if(loaiDashBoard == 'dash-board-chi-tra')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_QUY_CHI_TRA, obj);
        else if(loaiDashBoard == 'dash-board-mot-lan')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_QUY_MOT_LAN, obj);
        else if(loaiDashBoard == 'dash-board-hang-thang')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_QUY_HANG_THANG, obj);
    }

    thongKeNCCTheoThang(obj,loaiDashBoard) {
        if(loaiDashBoard == 'dash-board-mot-lan')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_THANG_MOT_LAN, obj);
        else if(loaiDashBoard == 'dash-board-hang-thang')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_THANG_HANG_THANG, obj);
    }

    tyLeGT(obj,loaiDashBoard) {
        if(loaiDashBoard == 'dash-board-ncc')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.TY_LE_GT, obj);
        else
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.TY_LE_GT_TRO_CAP, obj);
    }

    tyLeDT(obj,loaiDashBoard) {
        if(loaiDashBoard == 'dash-board-ncc')
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.TY_LE_DT, obj);
        else
            return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.TY_LE_DT_TRO_CAP, obj);
    }
    dashboardQuaLeTet(data){
        return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_QUA_LE_TET , data);
    }

    dashboardDieuDuong(data){
        return super.post(apiUrl.NGUOI_CO_CONG.DASH_BOARD.THONG_KE_THEO_DIEU_DUONG , data);
    }

    // Quyết định 290/2005/QĐ-TTG AGG
    AGGGetListHsQd2902005QdTtg(obj):Observable<any> {
        return super.post(apiUrl.AGG.HS_QD_290_2005_QD_TTG.GET_ALL, obj);
        }
        AGGAddHsQd2902005QdTtg(obj):Observable<any> {
        return super.post(apiUrl.AGG.HS_QD_290_2005_QD_TTG.ADD, obj);
        }
        AGGUpdateHsQd2902005QdTtg(requestBody) {
        return super.put(apiUrl.AGG.HS_QD_290_2005_QD_TTG.UPDATE, requestBody);
        }
        AGGGetDetailHsQd2902005QdTtg(id): Observable<any> {
        return super.get(apiUrl.AGG.HS_QD_290_2005_QD_TTG.DETAIL+ "?id=" +id);
        }
        AGGDeleteHsQd2902005QdTtg(id, trang_thai_xoa): Observable<any> {
        return super.delete(apiUrl.AGG.HS_QD_290_2005_QD_TTG.DELETE+ "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
        }
        AGGImportExcelHsQd2902005QdTtg(obj,file): Observable<any> {
            const token = localStorage.getItem('access_token');
            let headers = new HttpHeaders();
            headers = headers.append('Authorization', 'Bearer ' + token);
            headers.append('Access-Control-Allow-Origin', '*');
            const formData = new FormData();
            formData.append("thang", obj.thang);
            formData.append("nam", obj.nam);
            formData.append("file", obj.file);
            let api = apiUrl.AGG.HS_QD_290_2005_QD_TTG.IMPORT_EXCEL;
            if(obj.nam != null && obj.nam != "null") {
                api += "?nam=" + obj.nam;
            }
            if(obj.thang != null && obj.thang != "null") {
                api += "&thang=" + obj.thang;
            }
            return this.http.post(api, file, { reportProgress: true, headers });
        }


    // Quyết định 53/2010/QĐ-TTG AGG
    AGGGetListHsTaiNanLaoDong(obj):Observable<any> {
    return super.post(apiUrl.AGG.HS_TAI_NAN_LAO_DONG.GET_ALL, obj);
    }
    AGGAddHsTaiNanLaoDong(obj):Observable<any> {
    return super.post(apiUrl.AGG.HS_TAI_NAN_LAO_DONG.ADD, obj);
    }
    AGGUpdateHsTaiNanLaoDong(requestBody) {
    return super.put(apiUrl.AGG.HS_TAI_NAN_LAO_DONG.UPDATE, requestBody);
    }
    AGGGetDetailHsTaiNanLaoDong(id): Observable<any> {
    return super.get(apiUrl.AGG.HS_TAI_NAN_LAO_DONG.DETAIL+ "?id=" +id);
    }
    AGGDeleteHsTaiNanLaoDong(id, trang_thai_xoa): Observable<any> {
    return super.delete(apiUrl.AGG.HS_TAI_NAN_LAO_DONG.DELETE+ "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGImportExcelHsTaiNanLaoDong(obj): Observable<any> {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');
    const formData = new FormData();
    formData.append("thang", obj.thang);
    formData.append("nam", obj.nam);
    formData.append("file", obj.file);
    let api = apiUrl.AGG.HS_TAI_NAN_LAO_DONG.IMPORT_EXCEL;
    if(obj.nam != null && obj.nam != "null") {
        api += "?nam=" + obj.nam;
    }
    if(obj.thang != null && obj.thang != "null") {
        api += "&thang=" + obj.thang;
    }
    return this.http.post(api, formData, { reportProgress: true, headers });
    }
    AGGDownloadTemplateImportHsTaiNanLaoDong(filename){
    return super.downloadFile(apiUrl.AGG.HS_TAI_NAN_LAO_DONG.DOWNLOAD_TEMPLATE, filename);
    }


        AGGDownloadTemplateImportHsQd2902005QdTtg(filename){
            return super.downloadFile(apiUrl.AGG.HS_QD_290_2005_QD_TTG.DOWNLOAD_TEMPLATE, filename);
        }



    // Quyết định 53/2010/QĐ-TTG AGG
    AGGGetListHsQd532010QdTtg(obj):Observable<any> {
    return super.post(apiUrl.AGG.HS_QD_53_2010_QD_TTG.GET_ALL, obj);
    }
    AGGAddHsQd532010QdTtg(obj):Observable<any> {
    return super.post(apiUrl.AGG.HS_QD_53_2010_QD_TTG.ADD, obj);
    }
    AGGUpdateHsQd532010QdTtg(requestBody) {
    return super.put(apiUrl.AGG.HS_QD_53_2010_QD_TTG.UPDATE, requestBody);
    }
    AGGGetDetailHsQd532010QdTtg(id): Observable<any> {
    return super.get(apiUrl.AGG.HS_QD_53_2010_QD_TTG.DETAIL+ "?id=" +id);
    }
    AGGDeleteHsQd532010QdTtg(id, trang_thai_xoa): Observable<any> {
    return super.delete(apiUrl.AGG.HS_QD_53_2010_QD_TTG.DELETE+ "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    AGGImportExcelHsQd532010QdTtg(obj,file): Observable<any> {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');
    const formData = new FormData();
    formData.append("thang", obj.thang);
    formData.append("nam", obj.nam);
    formData.append("file", obj.file);
    let api = apiUrl.AGG.HS_QD_53_2010_QD_TTG.IMPORT_EXCEL;
    if(obj.nam != null && obj.nam != "null") {
        api += "?nam=" + obj.nam;
    }
    if(obj.thang != null && obj.thang != "null") {
        api += "&thang=" + obj.thang;
    }
    return this.http.post(api, file, { reportProgress: true, headers });
    }
    AGGDownloadTemplateImportHsQd532010QdTtg(filename){
    return super.downloadFile(apiUrl.AGG.HS_QD_53_2010_QD_TTG.DOWNLOAD_TEMPLATE, filename);
    }

    // AGG Quân nhân xuất ngũ
  AGGGetListHsQNXN(obj):Observable<any> {
    return super.post(apiUrl.AGG.HS_QNXN.GET_ALL, obj);
  }
  AGGUpdateHsQNXN(requestBody) {
    return super.put(apiUrl.AGG.HS_QNXN.UPDATE, requestBody);
  }
  AGGAddHsQNXN(requestBody) {
    return super.post(apiUrl.AGG.HS_QNXN.ADD, requestBody);
  }
  AGGGetDetailHsQNXN(id): Observable<any> {
    return super.get(apiUrl.AGG.HS_QNXN.DETAIL + "?id=" +id);
  }
  AGGDeleteHsQNXN(id, trang_thai_xoa): Observable<any> {
    return super.delete(apiUrl.AGG.HS_QNXN.DELETE + "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
  }
  AGGDownloadTemplateImportHsQNXN(filename):Observable<any>{
    return super.downloadFile(apiUrl.AGG.HS_QNXN.DOWNLOAD_TEMPLATE, filename);
  }
  AGGImportExcelHsQNXN(obj,file): Observable<any> {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');
    const formData = new FormData();
    formData.append("thang", obj.thang);
    formData.append("nam", obj.nam);
    formData.append("file", obj.file);
    let api = apiUrl.AGG.HS_QNXN.IMPORT_EXCEL;
    if(obj.nam != null && obj.nam != "null") {
      api += "?nam=" + obj.nam;
    }
    if(obj.thang != null && obj.thang != "null") {
      api += "&thang=" + obj.thang;
    }
    return this.http.post(api, file, { reportProgress: true, headers });
  }

  // AGG Công an xuất ngũ
  AGGGetListHsCAXN(obj):Observable<any> {
    return super.post(apiUrl.AGG.HS_CAXN.GET_ALL, obj);
  }
  AGGUpdateHsCAXN(requestBody) {
    return super.put(apiUrl.AGG.HS_CAXN.UPDATE, requestBody);
  }
  AGGAddHsCAXN(requestBody) {
    return super.post(apiUrl.AGG.HS_CAXN.ADD, requestBody);
  }
  AGGGetDetailHsCAXN(id): Observable<any> {
    return super.get(apiUrl.AGG.HS_CAXN.DETAIL + "?id=" +id);
  }
  AGGDeleteHsCAXN(id, trang_thai_xoa): Observable<any> {
    return super.delete(apiUrl.AGG.HS_CAXN.DELETE + "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
  }
  AGGDownloadTemplateImportHsCAXN(filename):Observable<any>{
    return super.downloadFile(apiUrl.AGG.HS_CAXN.DOWNLOAD_TEMPLATE, filename);
  }
  AGGImportExcelHsCAXN(obj,file): Observable<any> {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');
    const formData = new FormData();
    formData.append("thang", obj.thang);
    formData.append("nam", obj.nam);
    formData.append("file", obj.file);
    let api = apiUrl.AGG.HS_CAXN.IMPORT_EXCEL;
    if(obj.nam != null && obj.nam != "null") {
      api += "?nam=" + obj.nam;
    }
    if(obj.thang != null && obj.thang != "null") {
      api += "&thang=" + obj.thang;
    }
    return this.http.post(api, file, { reportProgress: true, headers });
  }
  AGGGetListHsTNXP(obj):Observable<any> {
    return super.post(apiUrl.AGG.THANHNIEN_XUNGPHONG.GET_DANH_SACH_THANH_NIEN_XUNG_PHONG, obj);
  }
  AGGAddHsTNXP(obj):Observable<any> {
    return super.post(apiUrl.AGG.THANHNIEN_XUNGPHONG.THEM_HS_THANH_NIEN_XUNG_PHONG, obj);
  }
  AGGEditHsTNXP(requestBody) {
    return super.put(apiUrl.AGG.THANHNIEN_XUNGPHONG.CAP_NHAT_HS_THANH_NIEN_XUNG_PHONG, requestBody);
  }
  AGGGetDetailHsTNXP(id): Observable<any> {
    return super.get(apiUrl.AGG.THANHNIEN_XUNGPHONG.CHI_TIET_HS_THANH_NIEN_XUNG_PHONG+ "?id=" +id);
  }
  AGGDeleteHsTNXP(id, trang_thai_xoa): Observable<any> {
    return super.delete(apiUrl.AGG.THANHNIEN_XUNGPHONG.XOA_HS_THANH_NIEN_XUNG_PHONG+ "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
  }
  AGGImportExcelHsTNXP(obj,file): Observable<any> {
      const token = localStorage.getItem('access_token');
      let headers = new HttpHeaders();
      headers = headers.append('Authorization', 'Bearer ' + token);
      headers.append('Access-Control-Allow-Origin', '*');
      const formData = new FormData();
      formData.append("thang", obj.thang);
      formData.append("nam", obj.nam);
      formData.append("file", obj.file);
      let api = apiUrl.AGG.THANHNIEN_XUNGPHONG.IMPORT_DS_THANH_NIEN_XUNG_PHONG;
      if(obj.nam != null && obj.nam != "null") {
          api += "?nam=" + obj.nam;
      }
      if(obj.thang != null && obj.thang != "null") {
          api += "&thang=" + obj.thang;
      }
      return this.http.post(api, file, { reportProgress: true, headers });
      }
  AGGDownloadTemplateImportHsTNXP(filename): Observable<any>{
      return super.downloadFile(apiUrl.AGG.THANHNIEN_XUNGPHONG.DOWNLOAD_TEMPLATE, filename);
      }
    // BHYT

    insertOrUpdateBHYT(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_BHYT , data);
    }

    getDSBHYT(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                param += key + '=' + data[key] + '&';
            }
        });
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_BHYT + "?" + param);
    }

    deleteDTBHYT(thongTinChiTraUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_BHYT +'?thongTinChiTraUuid=' +thongTinChiTraUuid);
    }

    catGiamDTBHYT(thongTinChiTraUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.CAT_GIAM_BHYT +'?thongTinChiTraUuid=' +thongTinChiTraUuid + '&trangThaiCatGiam=0');
    }

    // Trợ cấp quà

    getLisLoaiDoiTuong(){
        return super.get(apiUrl.NGUOI_CO_CONG.GETLISTDOITUONGQUA);
    }

    getDSQua(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                param += key + '=' + data[key] + '&';
            }
        });
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_QUA + "?" + param);
    }

    insertOrUpdateQua(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_QUA , data);
    }

    deleteDTQua(thongTinChiTraUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_QUA +'?thongTinChiTraUuid=' +thongTinChiTraUuid);
    }

    // Lịch sử trợ cấp
    getLichSuTroCap(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                param += key + '=' + data[key] + '&';
            }
        });
        return super.get(apiUrl.NGUOI_CO_CONG.LICH_SU_TRO_CAP + "?" + param);
    }

    // Chuyển đến / chuyển đi hồ sơ
    chuyenHSDi(data){
        return super.post(apiUrl.NGUOI_CO_CONG.CHUYEN_HS_DI, data);
    }

    searchListChuyen(obj): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.LIST_CHUYEN_HS, obj);
    }

    searchChiTietChuyen(obj): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.LIST_CHUYEN_HS, obj);
    }

    huyYCChuyen(idChuyen): Observable<any> {
        return super.delete(apiUrl.NGUOI_CO_CONG.HUY_YC_CHUYEN + "?chuyenUuid=" + idChuyen);
    }

    duyetTuChoiChuyen(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.DUYET_TC_CHUYEN, data);
    }

    yeuCauTuChoiChuyen(data): Observable<any> {
        return super.put(apiUrl.NGUOI_CO_CONG.YC_TU_CHOI_CHUYEN, data);
    }

    guiLaiYCChuyenHS(data): Observable<any> {
        return super.put(apiUrl.NGUOI_CO_CONG.GUI_LAI_YC_CHUYEN, data);
    }

    kiemTraYCChuyen(data): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.KIEM_TRA_YC_CHUYEN, data);
    }

    chuyenThangSangDiaPhuongKhac(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.CHUYEN_THANG_SANG_KHAC, data);
    }

    huyYCChuyenThang(idChuyen): Observable<any> {
        return super.delete(apiUrl.NGUOI_CO_CONG.HUY_CHUYEN_THANG + "?chuyenUuid=" + idChuyen);
    }
    //lịch sử đính chính
    getLichSuDinhChinh(body): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.LOG.GET_ALL, body);
    }

    // Giám định y khoa
    getDSGDYK(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                param += key + '=' + data[key] + '&';
            }
        });
        return super.get(apiUrl.NGUOI_CO_CONG.THONG_TIN_GDYK + "?" + param);
    }

    insertOrUpdateGDYK(data){
        return super.post(apiUrl.NGUOI_CO_CONG.THONG_TIN_GDYK , data);
    }

    deleteDTGDYK(thongTinChiTraUuid){
        return super.delete(apiUrl.NGUOI_CO_CONG.THONG_TIN_GDYK +'?thongTinGiamDinhYKhoaUuid=' +thongTinChiTraUuid +'&trangThaiXoa=true');
    }

    // Cắt chết
    yeuCauCatChet(data){
        return super.post(apiUrl.NGUOI_CO_CONG.YC_CAT_CHET , data);
    }

    searchListCatChet(obj): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.LIST_CAT_CHET, obj);
    }

    duyetTuChoiCatChet(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.DUYET_TC_CAT_CHET, data);
    }

    xoaYCCatChet(catChetUuid): Observable<any> {
        return super.delete(apiUrl.NGUOI_CO_CONG.XOA_CAT_CHET + "?catChetUuid=" + catChetUuid);
    }

    catChet(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.CAT_CHET, data);
    }

    huyCatChet(catChetUuid): Observable<any> {
        return super.delete(apiUrl.NGUOI_CO_CONG.HUY_CAT_CHET + "?catChetUuid=" + catChetUuid);
    }

    exportExcelQua(obj: any, fileName: string): Observable<any> {
      return super.downloadFile(apiUrl.NGUOI_CO_CONG.XUAT_EXCEL_DOI_TUONG_NHAN_QUA + "?" + this.bodyToString(obj), fileName);
    }

    //Xem báo cáo
    rootUrl_Micro = localStorage.getItem("url");
    getBaoCaoChung(data, url){
        return this.http.get(this.rootUrl_Micro + url + "?" + this.bodyToString(data), this.getRequestOptions());
    }

    postBaoCaoChung(data, url){
        return this.http.post(this.rootUrl_Micro + url, data, this.getRequestOptions());
    }

    getBaoCaoMauB07(data){
        return this.http.get(apiUrl.NGUOI_CO_CONG.BAO_CAO.BAO_CAO_B07 + "?" + this.bodyToString(data), this.getRequestOptions());
    }
    //Xuất báo cáo
    getXuatBaoCaoChung(data, url, tenFile){
        return super.downloadFile(this.rootUrl_Micro + url +  "?" + this.bodyToString(data), tenFile);
    }

    postXuatBaoCaoChung(data, url, nameFile){
        return super.downloadFile(this.rootUrl_Micro + url, nameFile, data);
    }

    // Thống kê hồ sơ
    thongKeHoSo(obj): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.THONG_KE_HO_SO, obj);
    }
    //Xem báo cáo

    getBaoCaoMauC75(data){
        return this.getBlob(apiUrl.NGUOI_CO_CONG.BAO_CAO.BAO_CAO_C75 + "?" + this.bodyToString(data));
    }
    //Xuất báo cáo
    xuatBaoCaoC73(maTinh, maXa, reportType, kyXuat){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.BAO_CAO_C73 + "?maTinh=" + maTinh + "&maXa=" + maXa + "&reportType=" + reportType + "&kyXuat=" + kyXuat, 'Bảng kê chi trả c73');
    }

    xuatBaoCaoC75(data){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.BAO_CAO_C75 +  "?" + this.bodyToString(data), 'Báo cáo giảm đối tượng hàng tháng');
    }

    getListVanBan(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.VAN_BAN_CHINH_SACH.GET_LIST, data);

    }

    xoaVanBan(id, trangThaiXoa): Observable<any> {
        return super.delete(apiUrl.NGUOI_CO_CONG.VAN_BAN_CHINH_SACH.DELETE, { id: id, trangThaiXoa: trangThaiXoa });
    }

    updateStatus(obj): Observable<any> {
        return super.put(apiUrl.NGUOI_CO_CONG.VAN_BAN_CHINH_SACH.UPDATE_STATUS, obj);
    }

    suaVanBan(data): Observable<any> {
        return super.put(apiUrl.NGUOI_CO_CONG.VAN_BAN_CHINH_SACH.UPDATE, data);
    }

    themVanBan(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.VAN_BAN_CHINH_SACH.ADD, data);
    }

    uploadFileVanBan(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.VAN_BAN_CHINH_SACH.UPLOAD_FILE, data);
    }

    downloadFileVanBan(fileId, tenFile){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.VAN_BAN_CHINH_SACH.DOWNLOAD_FILE +  "/" + fileId, tenFile);
    }

    xuatQuyetDinhTQGC(data){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.QUYET_DINH.XUAT_QUYET_DINH_TQGC +  "?" + this.bodyToString(data), data.kieuXuat == true ? 'Quyết định TQGC.pdf' : 'Quyết định TQGC.docx');
    }

    exportChuyenDenDi(data, tenFile): Observable<any> {
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.EXPORT_CHUYEN_DEN_DI, tenFile, data);
    }

    getListVanBanEoffice(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.VAN_BAN_EOFFICE.LIST_VAN_BAN, data);
    }

    uploadFileVanBanEofice(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.VAN_BAN_EOFFICE.UPLOAD_FILE, data);
    }

    downloadFileVanBanEoffice(fileId, tenFile){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.VAN_BAN_EOFFICE.DOWNLOAD_FILE +  "?fileName=" + fileId, tenFile);
    }

    getBaoCaoSoTay(): Observable<any>{
        return this.http.get(apiUrl.NGUOI_CO_CONG.BAO_CAO_SO_TAY, this.getRequestOptions());
    }

    postXuatBaoCaoSoTay(){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO_SO_TAY, "Báo cáo sổ tay số liệu của tất cả lĩnh vực.xlsx");
    }

    xemBaoCao304(data){
        return this.http.post(apiUrl.NGUOI_CO_CONG.BAO_CAO.BAO_CAO_304, data, this.getRequestOptions());
    }

    postXuatBaoCao304(data){
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.BAO_CAO.BAO_CAO_304, "Báo cáo mẫu 304", data);
    }

    getListBaoCao304(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.BAO_CAO_304.GET_LIST, data);

    }

    capNhatBaoCao(data): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.BAO_CAO_304.THEM_MOI_UPDATE, data);
    }

    getDanhSachFileChuyenQLVB(requestBody) {
        return super.post(apiUrl.NGUOI_CO_CONG.QUAN_LY_VAN_BAN.getDanhSachFileChuyenQLVB, requestBody);
    }

    dongBoTrangThai(requestBody) {
        return super.post(apiUrl.NGUOI_CO_CONG.QUAN_LY_VAN_BAN.dongBoTrangThai, requestBody);
    }

    chiTietQLVB(requestBody) {
        return super.post(apiUrl.NGUOI_CO_CONG.QUAN_LY_VAN_BAN.chiTietQLVB, requestBody);
    }

    uploadFileChuyenQLVB(requestBody): Observable<any> {
        return super.post(apiUrl.NGUOI_CO_CONG.QUAN_LY_VAN_BAN.uploadFileChuyenQLVB, requestBody);
    }

    danhSachFileDinhKemTheoId(obj): Observable<any> {
        return super.get(apiUrl.NGUOI_CO_CONG.QUAN_LY_VAN_BAN.danhSachFileDinhKemTheoId, obj);
    }

    checkThongTinQua(data): Observable<any>{
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                param += key + '=' + data[key] + '&';
            }
        });
        return super.get(apiUrl.NGUOI_CO_CONG.KIEM_TRA_TRUNG_THONG_TIN_QUA + "?" + param); 
    }

    exportDanhSachDoiTuongDieuDuong(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null && data[key] != 'null') {
              param += key + '=' + data[key] + '&';
            }
        });
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.EXPORT_DANH_SACH_DOI_TUONG_DIEU_DUONG + "?" + param, "Danh sách điều dưỡng");
    }

    exportDanhSachDoiTuongDCCH(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null && data[key] != 'null') {
              param += key + '=' + data[key] + '&';
            }
        });
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.EXPORT_DANH_SACH_DCCH + "?" + param, "Danh sách DCCH");
    }

    exportDanhSachDoiTuongNhanQua(data){
        var param = '';
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                param += key + '=' + data[key] + '&';
            }
        });
        return super.downloadFile(apiUrl.NGUOI_CO_CONG.EXPORT_DANH_SACH_DOI_TUONG_NHAN_QUA + "?" + param, "Danh sách đối tượng nhận quà");
    }

    exportDSNQCTN(obj: any, fileName: string): Observable<any> {
      return super.downloadFile(apiUrl.NGUOI_CO_CONG.EXPORT_DANH_SACH_DOI_TUONG_NHAN_QUA_TET_TU_CTN + "?" + this.bodyToString(obj), fileName);
    }

    exportDSNQNTC(obj: any, fileName: string): Observable<any> {
      return super.downloadFile(apiUrl.NGUOI_CO_CONG.EXPORT_DANH_SACH_DOI_TUONG_NHAN_QUA_TET_THO_CUNG + "?" + this.bodyToString(obj), fileName);
    }
    
    exportDanhSachNhanQuaTetTheoLoaiDoiTuong(obj: any, fileName: string): Observable<any> {
      return super.downloadFile(apiUrl.NGUOI_CO_CONG.EXPORT_DANH_SACH_NHAN_QUA_TET_THEO_LOAI_DOI_TUONG + "?" + this.bodyToString(obj), fileName);
    }
}
